export default __webpack_public_path__ + "static/media/ic-test-created.933cf386.svg";